import { useEffect, useState } from "react";
import { FormControl, MenuItem, Box, Select, IconButton, Tooltip, Autocomplete, TextField, Checkbox, Typography, Button, DialogActions, DialogContent, DialogTitle, Dialog, Menu } from "@mui/material";
import { SlOptions } from "react-icons/sl";
import { CiFilter } from "react-icons/ci";
// import { OTSheetCalender } from "./OTSheetCalender";
import { useNavigate } from "react-router-dom";
import { Controller, useForm } from "react-hook-form";
import dayjs from "dayjs";
import { Offcanvas } from "react-bootstrap";
import { DataGrid } from "@mui/x-data-grid";
import MoreVertIcon from "@mui/icons-material/MoreVert";
import OutlinedInput from "@mui/material/OutlinedInput";
import InfoOutlineIcon from "@mui/icons-material/InfoOutlined";
import { toast } from "react-toastify";
// import { createEntity, filterEntities, newFilterEntities } from "../../apis/apiService";
import SearchBar, { useDebounce } from "../../SearchBar";
import { useTheme } from "../../../ThemeContext";
import { useFetchGetallProjectsQuery, useFetchOTListsQuery } from "../../../slice/logdetailSlice";
import { CustomFooter, CustomNoRowsOverlay } from "../OverlayGrid";
import OTFilter from "../../../pages/otsheet/OTFilter";
import { OTSheetCalender } from "../../../pages/otsheet/OTSheetCalender";
import { createEntity, filterEntities } from "../../../apis/apiService";
import Loader from "../Loader";
import OTSheetDetail from "../../../pages/otsheet/OTSheetDetail";
import { setOTCounts } from "../../../selectSlice";
import RichText from "../RichText";
import { useDispatch } from "react-redux";
import { useLocation } from "react-router-dom";


const CommonOTSheet = ({ view_by_status, sheet_name }) => {
  const [openFilter, setOpenFilter] = useState(false);
  const [searchTerm, setSearchTerm] = useState("");
  const [loading, setLoading] = useState(false);
  const { isDarkMode } = useTheme();
  const [selectedProjectId, setSelectedProjectId] = useState(0);
  // const [expandedGroups, setExpandedGroups] = useState({});
  const [checkedRows, setCheckedRows] = useState({});
  const [selectedChildren, setSelectedChildren] = useState([]);
  const [editableRecords, setEditableRecords] = useState([]);
  const [statusModalOpen, setStatusModalOpen] = useState(false);
  const [selectedRowId, setSelectedRowId] = useState(null);
  const [selectedStatus, setSelectedStatus] = useState("Pending");
  const [infoPanelOpen, setInfoPanelOpen] = useState(false);
  const [selectedRow, setSelectedRow] = useState(null);
  const dispatch = useDispatch();
  const [anchorEl, setAnchorEl] = useState(null);
  const [totalHours, setTotalHours] = useState(null);
  const navigate = useNavigate();
  const location = useLocation();
  const menuOpen = Boolean(anchorEl);
  const debouncedSearchTerm = useDebounce(searchTerm, 500);
  const { data: project_list = [] } = useFetchGetallProjectsQuery();
  const [selectionRange, setSelectionRange] = useState(() => {
  const saved = localStorage.getItem("ot_date_range");

    if (saved) {
      const parsedDate = JSON.parse(saved);
      return {
        ...parsedDate,
        startDate: new Date(parsedDate.startDate),
        endDate: new Date(parsedDate.endDate),
      };
    }
    return {
      startDate: new Date(),
      endDate: new Date(),
      key: "selection",
    };
  });

  const [projectSpan, setProjectSpan] = useState(() => {
    return localStorage.getItem("ot_date_project_span") || "day";
  });
  const [clearFilter, setClearFilter] = useState(false);
  // const [collectionOfDatas, setCollectionOfDatas] = useState([]);

  const {
    data: ot_datas,
    refetch: ot_data_refetch,
    isLoading: ot_datas_loading,
  } = useFetchOTListsQuery({
    view_by_project: selectedProjectId,
    view_by_status: view_by_status,
    from_date: dayjs(selectionRange.startDate).format("YYYY-MM-DD"),
    to_date: dayjs(selectionRange.endDate).format("YYYY-MM-DD"),
    project_span: projectSpan,
    search: debouncedSearchTerm,
  });

  const handleSearchChange = async (event) => {
    const value = event.target.value;
    setSearchTerm(value);
  };

  useEffect(() => {
    if (ot_datas) {
      // setEditableRecords(ot_datas?.rerecords);
      setEditableRecords(JSON.parse(JSON.stringify(ot_datas?.records)));
      const newCounts = {
        total_count: ot_datas?.counts.total_count,
        total_pending: ot_datas?.counts.total_pending,
        total_approved: ot_datas?.counts.total_approved,
        total_rejected: ot_datas?.counts.total_rejected,
      };
      setTotalHours(ot_datas?.counts.total_hours || "00:00");
      localStorage.setItem("total_count", ot_datas?.counts.total_count);
      localStorage.setItem("total_pending", ot_datas?.counts.total_pending);
      localStorage.setItem("total_approved", ot_datas?.counts.total_approved);
      localStorage.setItem("total_rejected", ot_datas?.counts.total_rejected);
      dispatch(setOTCounts(newCounts));
    }
  }, [selectionRange.startDate, projectSpan, selectedProjectId, ot_datas]);

  useEffect(() => {
    ot_data_refetch();
    if (selectionRange?.startDate && selectionRange?.endDate) {
      localStorage.setItem(
        "ot_date_range",
        JSON.stringify({
          startDate: selectionRange.startDate,
          endDate: selectionRange.endDate,
          key: selectionRange.key,
        })
      );
      localStorage.setItem("ot_date_project_span", projectSpan);
    }
  }, [selectionRange.startDate, projectSpan, selectedProjectId]);

  const handleClearFilter = async () => {
    setClearFilter(false);
    setSearchTerm("");
    setSelectedProjectId(0);
    await ot_data_refetch();

    if (ot_datas?.records) {
      setEditableRecords(JSON.parse(JSON.stringify(ot_datas.records)));
    }
  };

  const hancleFilterChange = () => {
    setOpenFilter((prev) => !prev);
  };

  const getStatusStyle = (status) => {
    const statusStyles = {
      APPROVED: {
        backgroundColor: "#d1ecf1",
        color: "#0c5460",
        borderColor: "#bee5eb",
      },
      PENDING: {
        backgroundColor: "#e2d6f6",
        color: "#6f42c1",
        borderColor: "#c8b6e2",
      },
      REJECTED: {
        backgroundColor: "#f8d7da",
        color: "#a31616",
        borderColor: "#f5c6cb",
      },
    };
    return (
      statusStyles[status] || {
        backgroundColor: "#fff",
        color: "#000",
        borderColor: "#ccc",
      }
    );
  };

  const renderStatusCell = (params) => {
    const row = params.row;

    if (row.isGroup) return null;

    const statusValue = row.status;

    const statusStyles = {
      APPROVED: {
        backgroundColor: "#d1ecf1",
        color: "#0c5460",
        borderColor: "#bee5eb",
      },

      PENDING: {
        backgroundColor: "#e2d6f6",
        color: "#6f42c1",
        borderColor: "#c8b6e2",
      },

      REJECTED: {
        backgroundColor: "#f8d7da",
        color: "#a31616",
        borderColor: "#f5c6cb",
      },
    };

    const styles = statusStyles[statusValue] || {
      backgroundColor: "#fff",
      color: "#000",
      borderColor: "#ccc",
    };

    return (
      <Box
        sx={{
          display: "flex",
          alignItems: "center",
          justifyContent: "center",
          height: "100%",
          width: "100%",
        }}
      >
        <FormControl size="small" sx={{ width: 130 }}>
          <Select
            value={statusValue}
            onChange={(e) => handleUpdateInlineStatus(e, row.id)}
            disabled={row.is_editable === false}
            input={<OutlinedInput />}
            sx={{
              fontWeight: 600,
              borderRadius: "8px",
              "& .MuiSelect-icon": {
                color: styles.color,
              },
            }}
            componentsProps={{
              input: {
                sx: {
                  backgroundColor: styles.backgroundColor,
                  color: styles.color,
                  borderRadius: "8px",
                  // opacity: row.is_editable === false ? 0.6 : 1,
                },
              },
            }}
          >
            {["APPROVED", "PENDING", "REJECTED"].map((status) => (
              <MenuItem key={status} value={status}>
                {status.charAt(0) + status.slice(1).toLowerCase()}
              </MenuItem>
            ))}
          </Select>
        </FormControl>
      </Box>
    );
  };

  const handleInfoClick = (row) => {
    console.log("row_information :", row);

    setSelectedRow(row);
    // setInfoPanelOpen(true);
    // const basePath = location.pathname; // example: /OT-Sheet/Pending-Sheet
    // navigate(`${basePath}?date=${row.log_date}`, { state: { row } });
    navigate(`/OT-Sheet/OTSheetDetail?id=${row.id}`, { state: { row } });
  };

  const handleClosePanel = () => {
    setInfoPanelOpen(false); // Close the panel
    setSelectedRow(null); // Reset the selected row
  };

  const { control } = useForm();
  const getFlattenedRows = () => transformedRows || [];

  // const handleCheckboxChange = (rowId, rowData) => {
  //   const isGroup = rowData.row?.isGroup;
  //   const newCheckedRows = { ...checkedRows };

  //   if (isGroup) {
  //     // Get all children for this group
  //     const children = transformedRows.filter((row) => row.parentId === rowId);

  //     const newCheckedState = !checkedRows[rowId];

  //     // Update parent checkbox
  //     newCheckedRows[rowId] = newCheckedState;

  //     // Update all children checkboxes
  //     children.forEach((child) => {
  //       newCheckedRows[child.id] = newCheckedState;
  //     });

  //     // If checked, store only IDs of children
  //     if (newCheckedState) {
  //       const childIds = children.map((child) => child.id);
  //       setSelectedChildren(childIds);
  //       // console.log("Selected Child IDs:", childIds);
  //     } else {
  //       setSelectedChildren([]);
  //     }
  //   } else {
  //     newCheckedRows[rowId] = !checkedRows[rowId];

  //     if (!checkedRows[rowId]) {
  //       setSelectedChildren((prev) => [...prev, rowId]);
  //     } else {
  //       setSelectedChildren((prev) => prev.filter((id) => id !== rowId));
  //     }
  //   }

  //   setCheckedRows(newCheckedRows);
  // };

  const handleCheckboxChange = (rowId, rowData) => {
    const isGroup = rowData.row?.isGroup;
    const newCheckedRows = { ...checkedRows };

    if (isGroup) {
      // Get all editable children for this group
      const children = transformedRows.filter(
        (r) => r.parentId === rowId && r.is_editable !== false
      );

      const newCheckedState = !!!checkedRows[rowId];

      // Update parent checkbox
      newCheckedRows[rowId] = newCheckedState;

      // Update only editable children checkboxes
      children.forEach((child) => {
        newCheckedRows[child.id] = newCheckedState;
      });

      // Update selectedChildren to only editable child IDs when checked
      if (newCheckedState) {
        const childIds = children.map((child) => child.id);
        setSelectedChildren(childIds);
      } 
      else {
        setSelectedChildren([]);
      }
    } 
    else {
      // If this row itself is non-editable, ignore the click
      if (rowData.row?.is_editable === false) {
        return;
      }

      // Toggle this single row
      newCheckedRows[rowId] = !!!checkedRows[rowId];

      // Update selectedChildren (keep only editable ones)
      if (newCheckedRows[rowId]) {
        setSelectedChildren((prev) => {
          const merged = Array.from(new Set([...prev, rowId]));
          // ensure we only keep editable ones
          return merged.filter((id) => {
            const r = transformedRows.find((t) => t.id === id);
            return r ? r.is_editable !== false : true;
          });
        });
      } 
      else {
        setSelectedChildren((prev) => prev.filter((id) => id !== rowId));
      }

      // Also keep parent checkbox in sync (if this row has a parent)
      const parentId = rowData.row?.parentId;
      if (parentId) {
        const editableSiblings = transformedRows
          .filter((r) => r.parentId === parentId && r.is_editable !== false)
          .map((r) => r.id);

        // parent is checked only if ALL editable siblings are checked
        const allChecked =
          editableSiblings.length > 0 &&
          editableSiblings.every((id) => !!newCheckedRows[id]);
        newCheckedRows[parentId] = allChecked;
      }
    }

    setCheckedRows(newCheckedRows);
  };

  const isAnyChildSelected = (parentId) => {
    return transformedRows.some(
      (row) => row.parentId === parentId && checkedRows[row.id]
    );
  };

  const convertTo12HourFormat = (time) => {
    if (!time) return "";
    const [hours, minutes] = time.split(":").map(Number);
    const period = hours >= 12 ? "PM" : "AM";
    const convertedHours = hours % 12 || 12; // Convert 0 or 12 to 12 for AM/PM format
    return `${convertedHours}:${minutes.toString().padStart(2, "0")} ${period}`;
  };

  const transformedRows = editableRecords?.flatMap((record, index) => {
    const dateRowId = `date-${index}`;
    return [
      {
        id: dateRowId,
        log_date: record.log_date,
        isGroup: true, // helps in identifying the group header row
      },
      ...record.data.map((entry) => ({
        id: entry.time_logs_id,
        log_date: record.log_date,
        name: entry.owner?.name,
        creator_name: entry.creator?.name,
        ot_hours: entry.hours_in_text,
        status: entry.approval_status,
        billing_type: entry.billing_type,
        time_period:
          entry.start_time && entry.end_time
            ? `${convertTo12HourFormat(
                entry.start_time
              )} - ${convertTo12HourFormat(entry.end_time)}`
            : "N/A",
        project: entry.project?.title,
        task: entry.task?.title || entry.general_log_name || entry.title,
        notes: entry.notes,
        hours: entry.hours,
        reported_manager_name: entry?.reported_manager?.name,
        isSubtask: true,
        parentId: dateRowId,
        is_editable: entry.is_editable,
      })),
    ];
  });

  const columns = [
    {
      field: "actions",
      headerName: "Action",
      width: 120,
      renderCell: (params) => {
        const row = params.row;
        // console.log("Row ID:", row.id, "is_editable:", row.is_editable);

        if (!row.isGroup)
          return (
            <Box display="flex" alignItems="center" gap={1}>
              <Checkbox
                checked={!!checkedRows[row.id]}
                onChange={() => handleCheckboxChange(row.id, params)}
                disabled={row.is_editable === false}
                sx={{
                  "&.Mui-disabled": {
                    color: "#b0b0b0 !important", // grey color for disabled checkbox
                  },
                }}
              />
              <IconButton onClick={() => handleInfoClick(row)}>
                <InfoOutlineIcon />
              </IconButton>
            </Box>
          );

        return (
          <Box display="flex" alignItems="center" gap={1}>
            <Checkbox
              checked={!!checkedRows[row.id]}
              onChange={() => handleCheckboxChange(row.id, params)}
              disabled={areAllChildrenDisabled(row.id)}
              sx={{
                "&.Mui-disabled": {
                  color: "#b0b0b0 !important", // grey color for disabled checkbox
                },
              }}
            />
            <IconButton
              disabled={!checkedRows[row.id] && !isAnyChildSelected(row.id)}
              onClick={() => {
                const children = transformedRows.filter(
                  (child) => child.parentId === row.id && checkedRows[child.id]
                );
                 children.map((child) => ({
                  id: child.id,
                  status: child.status,
                }));
                // console.log("Selected child data:", selectedChildData);
                setSelectedRowId(row.id);
                setSelectedStatus(row.status || "PENDING");
                setStatusModalOpen(true);
              }}
            >
              <MoreVertIcon />
            </IconButton>
          </Box>
        );
      },
    },

    {
      field: "name",
      headerName: "Name",
      width: 150,
      renderCell: (params) => {
        const { row } = params;
        if (row.isGroup) {
          return (
            <Box fontWeight={900} display="flex" alignItems="center" gap={1}>
              {row.log_date}
            </Box>
          );
        }
        return row.isGroup ? row.log_date : row.name;
      },
    },

    {
      field: "ot_hours",
      headerName: "OT Hours",
      width: 160,
      renderCell: (params) => {
        const { row } = params;

        if (row.isGroup) return null;

        const otHours = row.ot_hours ?? "0";
        const totalHours = row.hours ?? 0;

        return (
          <Box>
            {otHours}{" "}
            <span style={{ color: "#777", fontSize: "12px" }}>
              ({totalHours} hrs)
            </span>
          </Box>
        );
      },
    },

    {
      field: "status",
      headerName: "Status",
      width: 200,
      renderCell: renderStatusCell,
      headerClassName: "sticky-column action-col",
      cellClassName: "sticky-column action-col",
    },

    { field: "time_period", headerName: "Time Period", width: 180 },
    { field: "project", headerName: "Project", width: 180 },
    { field: "task", headerName: "Tasks", width: 180 },
    // {
    //   field: "notes",
    //   headerName: "Notes",
    //   width: 200,
    //   renderCell: (params) => {
    //     if (params.row.isSubtask) {
    //       return (
    //         <Box
    //           display="flex"
    //           alignItems="center"
    //           justifyContent="center"
    //           width="100%"
    //           height="100%"
    //         >
    //           <Tooltip title={params.value || ""}>
    //             <Typography
    //               variant="body2"
    //               noWrap
    //               sx={{ textAlign: "center", width: "100%" }}
    //             >
    //               {params.value}
    //             </Typography>
    //           </Tooltip>
    //         </Box>
    //       );
    //     }
    //     return null;
    //   },
    // },

    {
      field: "notes",
      headerName: "Notes",
      width: 200,
      renderCell: (params) => {
        if (params.row.isSubtask) {
          return (
            <Box
              display="flex"
              alignItems="center"
              justifyContent="center"
              width="100%"
              height="100%"
            >
              <Tooltip
                title={
                  <RichText tag="div" style={{ padding: "8px" }} html={params.value || ""} />
                }
                arrow
              >
                <Typography
                  variant="body2"
                  noWrap
                  sx={{ textAlign: "left", width: "100%" }}
                >
                  {params.value?.replace(/<[^>]+>/g, "")}
                </Typography>
              </Tooltip>
            </Box>
          );
        }
        return null;
      },
    },

    { field: "creator_name", headerName: "Creator Name", width: 200 },

    {
      field: "billing_type",
      headerName: "Billing Type",
      width: 200,
      renderCell: (params) => {
        if (params.row.isSubtask) {
          return (
            <Box>
              <Typography
                sx={{
                  color: params.value === "BILLABLE" ? "#34C1FD" : "#FF955A",
                  mt: 2,
                }}
              >
                {params.value}
              </Typography>
            </Box>
          );
        }
        return null; // Return null for non-subtasks
      },
    },
  ];

  const handleMenuOpen = (event) => {
    setAnchorEl(event.currentTarget);
  };

  const handleCloseMenu = () => {
    setAnchorEl(null);
  };

  const handleExport = async () => {
    try {
      const requestedData = {
        view_by_project: selectedProjectId,
        view_by_status: 0,
        from_date: dayjs(selectionRange.startDate).format("YYYY-MM-DD"),
        to_date: dayjs(selectionRange.endDate).format("YYYY-MM-DD"),
        project_span: projectSpan,
        search: searchTerm,
        isExport: 1,
      };
      const response = await filterEntities("ot/getAllOts", requestedData);
      if (response) {
        toast.success(response.message);
        const file_url = response.data?.fileUrl;
        // const link = document.createElement("a");
        // link.href = file_url;
        // link.setAttribute("download", "");
        // document.body.appendChild(link);
        // link.click();
        // link.remove();
        const link = document.createElement("a");
        link.href = file_url;
        link.setAttribute("download", "");
        document.body.appendChild(link);
        link.click();
        link.remove();
      }
    }
     catch (err) {
      toast.error(err.message);
    } 
    finally {
      handleCloseMenu();
    }
  };

  const updateApprovalStatus = async (recordIds, approvalStatus) => {
    setLoading(true);
    const requestedData = {
      record_ids: Array.isArray(recordIds) ? recordIds : [recordIds],
      approval_status: approvalStatus,
    };

    try {
      const response = await createEntity("ot/update", requestedData);
      if (response) {
        toast.success(response.message);
        ot_data_refetch();
        setCheckedRows([]);
      }
    } 
    catch (err) {
      toast.error(err.message);
    } 
    finally {
      setStatusModalOpen(false);
      setLoading(false);
    }
  };

  const handleUpdateInlineStatus = (event, id) => {
    const value = event.target.value;
    // handleStatusChange(event, id);
    setSelectedChildren(id);
    setSelectedStatus(value);
    updateApprovalStatus(id, value);
  };

  const handleUpdateSheet = () => {
    updateApprovalStatus(selectedChildren, selectedStatus);
  };

  const areAllChildrenDisabled = (parentId) => {
    const children = transformedRows.filter((row) => row.parentId === parentId);
    return (
      children.length > 0 &&
      children.every((child) => child.is_editable === false)
    );
  };

  return (
    <>
      {loading || ot_datas_loading ? (
        <Loader />
      ) : (
        <div style={{ padding: "16px" }} className="bg-white">
          <Offcanvas show={openFilter} placement="end" style={{ width: "50%" }}>
            <Offcanvas.Body className="p-0">
              <OTFilter
                onCancel={() => setOpenFilter(false)}
                view_by_project={selectedProjectId}
                view_by_status={view_by_status}
                from_date={dayjs(selectionRange.startDate).format("YYYY-MM-DD")}
                to_date={dayjs(selectionRange.endDate).format("YYYY-MM-DD")}
                project_span={projectSpan}
                search={searchTerm}
                sheet_name={sheet_name}
                setClearFilter={setClearFilter}
                setEditableRecords={setEditableRecords}
              />
            </Offcanvas.Body>
          </Offcanvas>
          <Box sx={{ width: "100%" }} className="bg-transparent">
            {/* <div className="d-flex justify-content-between align-items-center flex-nowrap  gap-3"> */}
              {/* <div className="d-flex align-items-center  gap-3"> */}
               {/* Box tag using for border box for header content page  */}
          <Box
            className="d-flex justify-content-between align-items-center flex-nowrap gap-3"
            sx={{
              border: isDarkMode ? "1px solid #333" : "1px solid #e0e0e0",
              borderRadius: "6px",
              padding: "12px 16px",
              marginBottom: "16px",
              backgroundColor: isDarkMode ? "transparent" : "#fff",
            }}
          >
            <div className="d-flex align-items-center gap-3">
              <FormControl size="small">
                    
                <Controller
                  name="project_name"
                  control={control}
                  defaultValue={null}
                  render={({ field: { onChange, value } }) => (
                    <Autocomplete
                      fullWidth
                      size="small"
                      options={project_list}
                      getOptionLabel={(option) => option?.title || ""}
                      filterOptions={(options, state) => {
                        const inputValue = state.inputValue.toLowerCase();
                        return options.filter((option) =>
                          option?.title?.toLowerCase().includes(inputValue)
                        );
                      }}
                      value={
                        project_list.find(
                          (p) => p.project_id === value?.project_id
                        ) || null
                      }
                      onChange={(e, newValue) => {
                        onChange(newValue);
                        setSelectedProjectId(newValue?.project_id || 0);
                      }}
                      isOptionEqualToValue={(option, value) =>
                        option.project_id === value?.project_id
                      }
                      renderOption={(props, option, { selected }) => (
                        <li
                          {...props}
                          className="d-flex align-items-center mb-2"
                        >
                          <Checkbox
                            style={{ marginRight: 8 }}
                            checked={selected}
                          />
                          <strong>{option.title}</strong>
                        </li>
                      )}
                      renderInput={(params) => (
                        <TextField
                          {...params}
                          placeholder="Select Project"
                          variant="outlined"
                          InputProps={{
                            ...params.InputProps,
                              // disableUnderline: true,
                            sx: {
                              fontWeight: 500,
                              fontSize: 13,
                              borderRadius: "5px",
                              width: "300px",
                              padding: "6px 12px",
                              height: 36,
                            },
                          }}
                        />
                      )}
                      sx={{ width: "100%" }}
                    />
                  )}
                />
              </FormControl>
            </div>

            <div
              className="d-flex align-items-center justify-content-center gap-2"
              style={{ minWidth: 300 }}
            >
                {/* <IconButton>
              <ArrowBackIosIcon sx={{ fontSize: 15, color: "black" }} />
            </IconButton> */}
                {/* <div> */}
                
              <OTSheetCalender
                selectionRange={selectionRange}
                setSelectionRange={setSelectionRange}
                projectSpan={projectSpan}
                setProjectSpan={setProjectSpan}
                clearFilter={clearFilter}
                    // handleClear={handleClear}
                    // setClearFilter={setClearFilter}

                    //   refetch={refetch}
              />
            </div>

                {/* <IconButton>
              <ArrowForwardIosIcon sx={{ fontSize: 15, color: "black" }} />
            </IconButton> */}
              {/* </div> */}

              <div className="d-flex align-items-center flex-nowrap" style={{ gap: "7px" }}>                                 
              <SearchBar
                placeholder="Search Staff Name"
                searchTerm={searchTerm}
                onSearchChange={handleSearchChange}
              />

              {clearFilter && (
                <button
                    className=" addmore_btn"
                  disabled={loading}
                  onClick={handleClearFilter}
                >
                  Clear Filter
                </button>
              )}

              <Tooltip title="Filter">
                <IconButton
                  className="d-flex align-items-center justify-content-center me-2"
                  sx={{
                    backgroundColor: isDarkMode
                      ? "rgba(67, 105, 255, 0.08)"
                      : "#F1F5FF",
                    borderRadius: "50%",
                    width: "40px",
                    height: "40px",
                    padding: "5px",
                    "&:hover": {
                      backgroundColor: "var(--icon-hover-bg)",
                    },
                  }}
                  // >
                  //   <CiFilter
                  //     className="text-rgbr-blue pro-icon-s"
                  onClick={hancleFilterChange}
                    // />
                  >
                  <CiFilter className="text-rgbr-blue pro-icon-s" size={23} />
                </IconButton>
              </Tooltip>

              <Tooltip title="Export">
                <IconButton
                  className="d-flex align-items-center justify-content-center"
                  sx={{
                    backgroundColor: isDarkMode
                      ? "rgba(67, 105, 255, 0.08)"
                      : "#F1F5FF",
                    borderRadius: "50%",
                    width: "40px",
                    height: "40px",
                    padding: "10px",
                    "&:hover": {
                      backgroundColor: "var(--icon-hover-bg)",
                    },
                  }}
                  onClick={handleMenuOpen}
                >
                    <SlOptions size={20} className="text-rgbr-blue " />
                </IconButton>
              </Tooltip>

              <Menu
                anchorEl={anchorEl}
                open={menuOpen}
                onClose={handleCloseMenu}
                PaperProps={{ sx: { borderRadius: "8px" } }}
              >
                <MenuItem onClick={handleExport}>Export</MenuItem>
              </Menu>
              {/* </div> */}
            </div>
          </Box>
          </Box>

          <div className="my-3">
            <DataGrid
              columns={columns}
              rows={getFlattenedRows()}
              getRowId={(row) => row?.id}
                loading={loading || ot_datas_loading}
                
              // slots={{
              //   noRowsOverlay: CustomNoRowsOverlay,
                // }}
              disableColumnMenu
              disableColumnSorting
              disableColumnFilter
              disableColumnSelector
              slots={{
                noRowsOverlay: CustomNoRowsOverlay,
                footer: () => (
                  <CustomFooter
                    totalLogHours={
                      getFlattenedRows().length === 0
                        ? "00:00"
                        : totalHours ?? "00:00"
                    }
                  />
                ),
              }}
            />
          </div>

          <Offcanvas
            show={infoPanelOpen}
            placement="end"
            style={{ width: "30%" }}
            onHide={handleClosePanel}
          >
            <Offcanvas.Body>
              <OTSheetDetail
                selectedRow={selectedRow}
                handleClosePanel={handleClosePanel}
              />
            </Offcanvas.Body>
          </Offcanvas>

          <Dialog
            open={statusModalOpen}
            onClose={() => setStatusModalOpen(false)}
          >
            
            <DialogTitle>OT Status</DialogTitle>
            <DialogContent sx={{ minWidth: 400 }}>
              <Box display="flex" flexDirection="column" gap={2} mt={1}>
                <FormControl size="small" sx={{ width: 150 }}>
                  <Select
                    value={selectedStatus}
                    onChange={(e) => setSelectedStatus(e.target.value)}
                    input={<OutlinedInput />}
                    sx={{
                      fontWeight: 600,
                      borderRadius: "8px",
                      "& .MuiSelect-icon": {
                        color: getStatusStyle(selectedStatus).color,
                      },
                    }}
                    componentsProps={{
                      input: {
                        sx: {
                          backgroundColor:
                            getStatusStyle(selectedStatus).backgroundColor,
                          color: getStatusStyle(selectedStatus).color,
                          borderRadius: "8px",
                        },
                      },
                    }}
                  >
                    {["APPROVED", "PENDING", "REJECTED"].map((status) => (
                      <MenuItem key={status} value={status}>
                        {status.charAt(0) + status.slice(1).toLowerCase()}
                      </MenuItem>
                    ))}
                  </Select>
                </FormControl>

                <Typography>
                  Are you sure want to change the status for selected user?
                </Typography>
              </Box>
            </DialogContent>

            <DialogActions>
              <Button
                onClick={() => setStatusModalOpen(false)}
                sx={{ color: "#999" }}
              >
                Cancel
              </Button>
              <Button
                variant="contained"
                sx={{
                  backgroundColor: "#28a745",
                  "&:hover": { backgroundColor: "#218838" },
                }}
                onClick={handleUpdateSheet}
              >
                Save
              </Button>
            </DialogActions>
          </Dialog>
        </div>
      )}
    </>
  );
};

export default CommonOTSheet;
